enum EAddCredit {
  NUVEMPAGO = 'nuvempago',
  DEFAULT = 'default'
}

enum EApiBalance {
  NUVEM_PAGO_BALANCE = 'nuvem-pago-balance'
}

const RETRY_BALANCE_COUNT = 3;

export { EAddCredit, RETRY_BALANCE_COUNT, EApiBalance };
